export default class BannerEnum {
    static VIDEO = '[data-banner-video]'
    static SLIDER = '[data-banner-slider]'
    static SLIDER_NAVIGATION_NEXT = '[data-customer-navigation="banner-next"]'
    static SLIDER_NAVIGATION_PREV = '[data-customer-navigation="banner-prev"]'
}
